import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration__compareTo_impl_pchp0f1efu9z6fxx84c as Duration__compareTo_impl_pchp0f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  DurationUnit_DAYS_getInstance3he068lsy3pdd as DurationUnit_DAYS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IdAndAuthMethods16spukjsbhqxj as IdAndAuthMethods,
  ProofsCheckResultbn4a1zrk4ejf as ProofsCheckResult,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/sessionModels.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../LsErrorException.mjs';
import { LSError2xrpo13ez2d1 as LSError } from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/LSError.mjs';
import {
  Proof2281nhajm8urn as Proof,
  KnownDeviceOptionsfe8mpyitu56v as KnownDeviceOptions,
  KnownDeviceSecretAndExpirationmwpgc73vjaua as KnownDeviceSecretAndExpiration,
  ProofMethodInfo36q47k2opsjdz as ProofMethodInfo,
  ProofOption3e15jtcqm4fpv as ProofOption,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/proofModels.mjs';
import {
  get_via1yox8ba35wqel as get_via,
  get_property2y9s85dtwsuvs as get_property,
  Sms390uee2xgepqo as Sms,
  get_via38yy5q0f9oxer as get_via_0,
  get_property364tzqq3z832r as get_property_0,
  Email1w7ox5oeijz9q as Email,
  get_via1akmqcvk1uw2r as get_via_1,
  get_property3fywtt2wxtx70 as get_property_1,
  Password2oz6lme4sxm35 as Password,
  get_via1qy3fim7enjl0 as get_via_2,
  TimeBasedOTP8rvmui1ob933 as TimeBasedOTP,
  ProofClientEndpoints22835nuu8vpwr as ProofClientEndpoints,
  get_viaslgbb3rik8va as get_via_3,
  WebAuthN1n668ofp4zkcr as WebAuthN,
  get_via1dsogpg00hdlv as get_via_4,
  BackupCode2jc2vekqp19f0 as BackupCode,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/ProofClientEndpoints.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PublicKeyCredentialRequestOptions1z3k9pcbf380y as PublicKeyCredentialRequestOptions,
  StartResponse1sgjxr7oj7f5v as StartResponse,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/WebAuthN.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  mapOf2zpbbmyqk8xpf as mapOf_0,
  listOfvhqybd2zx248 as listOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Companion_getInstance138pnyl3l6agm as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function accessToken(_this__u8e3s4, sessionToken) {
  return accessToken_0(_this__u8e3s4, sessionToken, null);
}
var AuthEndpoints$Companion$dummy$1Class;
function AuthEndpoints$Companion$dummy$1() {
  if (AuthEndpoints$Companion$dummy$1Class === VOID) {
    class $ {
      *getTokenSimple_ybyi9u_k$(input, $completion) {
        return '';
      }
      *getSelf_biektx_k$($completion) {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
      getSelf_ivto1e_k$($completion) {
        return this.getSelf_biektx_k$($completion);
      }
      get_11bmbq_k$(proofs) {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = proofs.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.property_1 === 'email') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringBefore(tmp1_safe_receiver, _Char___init__impl__6a9atx(64));
        var id = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(43));
        // Inline function 'kotlin.collections.get' call
        var this_0 = Companion_getInstance_1().methodLookup_1;
        var tmp3_elvis_lhs = (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).get_wei43m_k$(id);
        return tmp3_elvis_lhs == null ? ensureNotNull(Companion_getInstance_1().methodLookup_1.get_wei43m_k$('all')) : tmp3_elvis_lhs;
      }
      *logInV2_mi0ogi_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.get_11bmbq_k$(input.proofs_1);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.map' call
          var this_0 = input.proofs_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp$ret$6 = item.via_1;
            destination_0.add_utx5q5_k$(tmp$ret$6);
          }
          if (!destination_0.contains_aljjnj_k$(element.method_1.via_1)) {
            destination.add_utx5q5_k$(element);
          }
        }
        var tmp = destination;
        var tmp_0;
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_1 = input.proofs_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp_1 = sum;
          sum = tmp_1 + element_0.strength_1 | 0;
        }
        if (sum >= 3) {
          tmp_0 = '';
        } else {
          tmp_0 = null;
        }
        return new (IdAndAuthMethods())('id', tmp, 3, tmp_0);
      }
      logInV2_lw4xp7_k$(input, $completion) {
        return this.logInV2_mi0ogi_k$(input, $completion);
      }
      *checkProofs_gdw9g0_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.get_11bmbq_k$(input);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(input, 10));
          var _iterator__ex2g4s_0 = input.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp$ret$6 = item.via_1;
            destination_0.add_utx5q5_k$(tmp$ret$6);
          }
          if (!destination_0.contains_aljjnj_k$(element.method_1.via_1)) {
            destination.add_utx5q5_k$(element);
          }
        }
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.days' call
        Companion_getInstance();
        var tmp$ret$7 = toDuration(7, DurationUnit_DAYS_getInstance());
        var tmp1_maxExpiration = tmp.plus_tegsqz_k$(tmp$ret$7);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_1 = input.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp_0 = sum;
          sum = tmp_0 + element_0.strength_1 | 0;
        }
        var tmp2_readyToLogIn = sum >= 3;
        return new (ProofsCheckResult())('id', destination, 3, tmp2_readyToLogIn, tmp1_maxExpiration);
      }
      checkProofs_qk2dxf_k$(input, $completion) {
        return this.checkProofs_gdw9g0_k$(input, $completion);
      }
      *terminateSession_4mdhei_k$($completion) {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
      terminateSession_ckz0qq_k$($completion) {
        return this.terminateSession_4mdhei_k$($completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1, 0]);
    AuthEndpoints$Companion$dummy$1Class = $;
  }
  return AuthEndpoints$Companion$dummy$1Class;
}
var AuthEndpoints$Companion$dummy$2Class;
function AuthEndpoints$Companion$dummy$2() {
  if (AuthEndpoints$Companion$dummy$2Class === VOID) {
    class $ {
      *beginSmsOwnershipProof_phcxbm_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        return input;
      }
      *provePhoneOwnership_vb71rh_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        if (input.password_1 === 'wrong')
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(400, '', 'Code incorrect. 4 attempts remain', ''));
        var tmp0_value = input.key_1;
        var tmp1_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp2_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('sms', VOID, 'phone', tmp0_value, tmp1_at, tmp2_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via;
    protoOf($).get_property_msvula_k$ = get_property;
    initMetadataForClass($, VOID, VOID, VOID, [Sms()], [1]);
    AuthEndpoints$Companion$dummy$2Class = $;
  }
  return AuthEndpoints$Companion$dummy$2Class;
}
var AuthEndpoints$Companion$dummy$3Class;
function AuthEndpoints$Companion$dummy$3() {
  if (AuthEndpoints$Companion$dummy$3Class === VOID) {
    class $ {
      *beginEmailOwnershipProof_z98tf3_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        return input;
      }
      *proveEmailOwnership_zd3jgf_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        if (input.password_1 === 'wrong')
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(400, '', 'Code incorrect. 4 attempts remain', ''));
        var tmp0_value = input.key_1;
        var tmp1_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp2_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('email', VOID, 'email', tmp0_value, tmp1_at, tmp2_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_0;
    protoOf($).get_property_msvula_k$ = get_property_0;
    initMetadataForClass($, VOID, VOID, VOID, [Email()], [1]);
    AuthEndpoints$Companion$dummy$3Class = $;
  }
  return AuthEndpoints$Companion$dummy$3Class;
}
var AuthEndpoints$Companion$dummy$4Class;
function AuthEndpoints$Companion$dummy$4() {
  if (AuthEndpoints$Companion$dummy$4Class === VOID) {
    class $ {
      *provePasswordOwnership_n5u26d_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        if (input.password_1 === 'wrong')
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(400, '', 'Password and user do not match', ''));
        var tmp0_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp1_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('password', VOID, 'password', 'id', tmp0_at, tmp1_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_1;
    protoOf($).get_property_msvula_k$ = get_property_1;
    initMetadataForClass($, VOID, VOID, VOID, [Password()], [1]);
    AuthEndpoints$Companion$dummy$4Class = $;
  }
  return AuthEndpoints$Companion$dummy$4Class;
}
var AuthEndpoints$Companion$dummy$5Class;
function AuthEndpoints$Companion$dummy$5() {
  if (AuthEndpoints$Companion$dummy$5Class === VOID) {
    class $ {
      *proveOTP_hnj5ta_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        if (input.password_1 === 'wrong')
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(400, '', 'OTP and user do not match', ''));
        var tmp0_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp1_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('otp', VOID, 'otp', 'id', tmp0_at, tmp1_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_2;
    protoOf($).get_property_msvula_k$ = get_property_1;
    initMetadataForClass($, VOID, VOID, VOID, [TimeBasedOTP()], [1]);
    AuthEndpoints$Companion$dummy$5Class = $;
  }
  return AuthEndpoints$Companion$dummy$5Class;
}
var AuthEndpoints$Companion$dummy$6Class;
function AuthEndpoints$Companion$dummy$6() {
  if (AuthEndpoints$Companion$dummy$6Class === VOID) {
    class $ {
      *knownDeviceOptions_ut629v_k$($completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        // Inline function 'kotlin.time.Companion.days' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(30, DurationUnit_DAYS_getInstance());
        return new (KnownDeviceOptions())(tmp$ret$1, 1);
      }
      *establishKnownDeviceV2_gsx0du_k$($completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.days' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(30, DurationUnit_DAYS_getInstance());
        return new (KnownDeviceSecretAndExpiration())('ok', tmp.plus_tegsqz_k$(tmp$ret$1));
      }
    }
    protoOf($).get_property_msvula_k$ = get_property_1;
    initMetadataForClass($, VOID, VOID, VOID, [ProofClientEndpoints()], [1, 0]);
    AuthEndpoints$Companion$dummy$6Class = $;
  }
  return AuthEndpoints$Companion$dummy$6Class;
}
var AuthEndpoints$Companion$dummy$7Class;
function AuthEndpoints$Companion$dummy$7() {
  if (AuthEndpoints$Companion$dummy$7Class === VOID) {
    class $ {
      *start_cy6iof_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        return new (StartResponse())('sfhfhfsghdgjdghjfsgsgbbcnkfhkjrtshgdzfgv', new (PublicKeyCredentialRequestOptions())(VOID, 'sfhfhfsghdgjdghjfsgsgbbcnkfhkjrtshgdzfgv', VOID, VOID, 'com.test'));
      }
      *prove_7gsw9i_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        var tmp0_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp1_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('WebAuthN', VOID, 'WebAuthN', 'id', tmp0_at, tmp1_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_3;
    protoOf($).get_property_msvula_k$ = get_property_1;
    initMetadataForClass($, VOID, VOID, VOID, [WebAuthN()], [1]);
    AuthEndpoints$Companion$dummy$7Class = $;
  }
  return AuthEndpoints$Companion$dummy$7Class;
}
var AuthEndpoints$Companion$dummy$8Class;
function AuthEndpoints$Companion$dummy$8() {
  if (AuthEndpoints$Companion$dummy$8Class === VOID) {
    class $ {
      *proveBackupCode_juqyr2_k$(input, $completion) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        if (input.password_1 === 'wrong')
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(400, '', 'OTP and user do not match', ''));
        var tmp0_at = System_instance.now_2cba_k$();
        var tmp = System_instance.now_2cba_k$();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
        var tmp1_expiresAt = tmp.plus_tegsqz_k$(tmp$ret$1);
        return new (Proof())('backupcode', VOID, 'backupcode', 'id', tmp0_at, tmp1_expiresAt, '');
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_4;
    protoOf($).get_property_msvula_k$ = get_property_1;
    initMetadataForClass($, VOID, VOID, VOID, [BackupCode()], [1, 0]);
    AuthEndpoints$Companion$dummy$8Class = $;
  }
  return AuthEndpoints$Companion$dummy$8Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = to('all', listOf([new (ProofOption())(new (ProofMethodInfo())('email', 'email'), 'test@test.com'), new (ProofOption())(new (ProofMethodInfo())('sms', 'phone'), '801-000-0000'), new (ProofOption())(new (ProofMethodInfo())('password', null)), new (ProofOption())(new (ProofMethodInfo())('otp', null)), new (ProofOption())(new (ProofMethodInfo())('backupcode', null)), new (ProofOption())(new (ProofMethodInfo())('WebAuthN', null))]));
        var tmp_1 = to('emailpass', listOf([new (ProofOption())(new (ProofMethodInfo())('email', 'email'), 'test@test.com'), new (ProofOption())(new (ProofMethodInfo())('password', null))]));
        var tmp_2 = to('emailpassotp', listOf([new (ProofOption())(new (ProofMethodInfo())('email', 'email'), 'test@test.com'), new (ProofOption())(new (ProofMethodInfo())('password', null)), new (ProofOption())(new (ProofMethodInfo())('otp', null)), new (ProofOption())(new (ProofMethodInfo())('backupcode', null))]));
        var tmp_3 = to('emailpasswebauth', listOf([new (ProofOption())(new (ProofMethodInfo())('email', 'email'), 'test@test.com'), new (ProofOption())(new (ProofMethodInfo())('WebAuthN', null))]));
        var tmp_4 = to('phonepass', listOf([new (ProofOption())(new (ProofMethodInfo())('sms', 'phone'), '801-000-0000'), new (ProofOption())(new (ProofMethodInfo())('password', null))]));
        var tmp_5 = to('phonepassotp', listOf([new (ProofOption())(new (ProofMethodInfo())('sms', 'phone'), '801-000-0000'), new (ProofOption())(new (ProofMethodInfo())('password', null)), new (ProofOption())(new (ProofMethodInfo())('otp', null)), new (ProofOption())(new (ProofMethodInfo())('backupcode', null))]));
        var tmp_6 = to('phonepasswebauth', listOf([new (ProofOption())(new (ProofMethodInfo())('sms', 'phone'), '801-000-0000'), new (ProofOption())(new (ProofMethodInfo())('WebAuthN', null))]));
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp.methodLookup_1 = mapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, to('none', tmp$ret$0)]);
        var tmp_7 = this;
        var tmp0_subjects = mapOf_0(to('User', new (AuthEndpoints$Companion$dummy$1())()));
        var tmp1_smsProof = new (AuthEndpoints$Companion$dummy$2())();
        var tmp2_emailProof = new (AuthEndpoints$Companion$dummy$3())();
        var tmp3_passwordProof = new (AuthEndpoints$Companion$dummy$4())();
        var tmp4_oneTimePasswordProof = new (AuthEndpoints$Companion$dummy$5())();
        var tmp5_knownDeviceProof = new (AuthEndpoints$Companion$dummy$6())();
        var tmp6_webAuthNProof = new (AuthEndpoints$Companion$dummy$7())();
        var tmp7_backupCodeProof = new (AuthEndpoints$Companion$dummy$8())();
        tmp_7.dummy_1 = new (AuthEndpoints())(tmp0_subjects, VOID, tmp1_smsProof, tmp2_emailProof, tmp4_oneTimePasswordProof, tmp3_passwordProof, tmp7_backupCodeProof, tmp5_knownDeviceProof, tmp6_webAuthNProof);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function AuthEndpoints$_init_$lambda_k9yai3(_this__u8e3s4, it) {
  return _this__u8e3s4.copy$default_m5imh4_k$(VOID, it);
}
var AuthEndpointsClass;
function AuthEndpoints() {
  if (AuthEndpointsClass === VOID) {
    class $ {
      constructor(subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication) {
        Companion_getInstance_1();
        authentication = authentication === VOID ? null : authentication;
        smsProof = smsProof === VOID ? null : smsProof;
        emailProof = emailProof === VOID ? null : emailProof;
        oneTimePasswordProof = oneTimePasswordProof === VOID ? null : oneTimePasswordProof;
        passwordProof = passwordProof === VOID ? null : passwordProof;
        backupCodeProof = backupCodeProof === VOID ? null : backupCodeProof;
        knownDeviceProof = knownDeviceProof === VOID ? null : knownDeviceProof;
        webAuthNProof = webAuthNProof === VOID ? null : webAuthNProof;
        webAuthNIncludePasskeyUI = webAuthNIncludePasskeyUI === VOID ? !(webAuthNProof == null) : webAuthNIncludePasskeyUI;
        var tmp;
        if (withAuthentication === VOID) {
          tmp = AuthEndpoints$_init_$lambda_k9yai3;
        } else {
          tmp = withAuthentication;
        }
        withAuthentication = tmp;
        this.subjects_1 = subjects;
        this.authentication_1 = authentication;
        this.smsProof_1 = smsProof;
        this.emailProof_1 = emailProof;
        this.oneTimePasswordProof_1 = oneTimePasswordProof;
        this.passwordProof_1 = passwordProof;
        this.backupCodeProof_1 = backupCodeProof;
        this.knownDeviceProof_1 = knownDeviceProof;
        this.webAuthNProof_1 = webAuthNProof;
        this.webAuthNIncludePasskeyUI_1 = webAuthNIncludePasskeyUI;
        this.withAuthentication_1 = withAuthentication;
      }
      withAuth_n8dse1_k$(auth) {
        return equals(auth, this.authentication_1) ? this : this.withAuthentication_1(this, auth);
      }
      copy_szlnq6_k$(subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication) {
        return new (AuthEndpoints())(subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication);
      }
      copy$default_m5imh4_k$(subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication, $super) {
        subjects = subjects === VOID ? this.subjects_1 : subjects;
        authentication = authentication === VOID ? this.authentication_1 : authentication;
        smsProof = smsProof === VOID ? this.smsProof_1 : smsProof;
        emailProof = emailProof === VOID ? this.emailProof_1 : emailProof;
        oneTimePasswordProof = oneTimePasswordProof === VOID ? this.oneTimePasswordProof_1 : oneTimePasswordProof;
        passwordProof = passwordProof === VOID ? this.passwordProof_1 : passwordProof;
        backupCodeProof = backupCodeProof === VOID ? this.backupCodeProof_1 : backupCodeProof;
        knownDeviceProof = knownDeviceProof === VOID ? this.knownDeviceProof_1 : knownDeviceProof;
        webAuthNProof = webAuthNProof === VOID ? this.webAuthNProof_1 : webAuthNProof;
        webAuthNIncludePasskeyUI = webAuthNIncludePasskeyUI === VOID ? this.webAuthNIncludePasskeyUI_1 : webAuthNIncludePasskeyUI;
        withAuthentication = withAuthentication === VOID ? this.withAuthentication_1 : withAuthentication;
        return $super === VOID ? this.copy_szlnq6_k$(subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication) : $super.copy_szlnq6_k$.call(this, subjects, authentication, smsProof, emailProof, oneTimePasswordProof, passwordProof, backupCodeProof, knownDeviceProof, webAuthNProof, webAuthNIncludePasskeyUI, withAuthentication);
      }
      toString() {
        return 'AuthEndpoints(subjects=' + toString(this.subjects_1) + ', authentication=' + toString_0(this.authentication_1) + ', smsProof=' + toString_0(this.smsProof_1) + ', emailProof=' + toString_0(this.emailProof_1) + ', oneTimePasswordProof=' + toString_0(this.oneTimePasswordProof_1) + ', passwordProof=' + toString_0(this.passwordProof_1) + ', backupCodeProof=' + toString_0(this.backupCodeProof_1) + ', knownDeviceProof=' + toString_0(this.knownDeviceProof_1) + ', webAuthNProof=' + toString_0(this.webAuthNProof_1) + ', webAuthNIncludePasskeyUI=' + this.webAuthNIncludePasskeyUI_1 + ', withAuthentication=' + toString(this.withAuthentication_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.subjects_1);
        result = imul(result, 31) + (this.authentication_1 == null ? 0 : this.authentication_1.hashCode()) | 0;
        result = imul(result, 31) + (this.smsProof_1 == null ? 0 : hashCode(this.smsProof_1)) | 0;
        result = imul(result, 31) + (this.emailProof_1 == null ? 0 : hashCode(this.emailProof_1)) | 0;
        result = imul(result, 31) + (this.oneTimePasswordProof_1 == null ? 0 : hashCode(this.oneTimePasswordProof_1)) | 0;
        result = imul(result, 31) + (this.passwordProof_1 == null ? 0 : hashCode(this.passwordProof_1)) | 0;
        result = imul(result, 31) + (this.backupCodeProof_1 == null ? 0 : hashCode(this.backupCodeProof_1)) | 0;
        result = imul(result, 31) + (this.knownDeviceProof_1 == null ? 0 : hashCode(this.knownDeviceProof_1)) | 0;
        result = imul(result, 31) + (this.webAuthNProof_1 == null ? 0 : hashCode(this.webAuthNProof_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.webAuthNIncludePasskeyUI_1) | 0;
        result = imul(result, 31) + hashCode(this.withAuthentication_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthEndpoints()))
          return false;
        if (!equals(this.subjects_1, other.subjects_1))
          return false;
        if (!equals(this.authentication_1, other.authentication_1))
          return false;
        if (!equals(this.smsProof_1, other.smsProof_1))
          return false;
        if (!equals(this.emailProof_1, other.emailProof_1))
          return false;
        if (!equals(this.oneTimePasswordProof_1, other.oneTimePasswordProof_1))
          return false;
        if (!equals(this.passwordProof_1, other.passwordProof_1))
          return false;
        if (!equals(this.backupCodeProof_1, other.backupCodeProof_1))
          return false;
        if (!equals(this.knownDeviceProof_1, other.knownDeviceProof_1))
          return false;
        if (!equals(this.webAuthNProof_1, other.webAuthNProof_1))
          return false;
        if (!(this.webAuthNIncludePasskeyUI_1 === other.webAuthNIncludePasskeyUI_1))
          return false;
        if (!equals(this.withAuthentication_1, other.withAuthentication_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthEndpoints');
    AuthEndpointsClass = $;
  }
  return AuthEndpointsClass;
}
function accessToken_0(_this__u8e3s4, sessionToken, forceInvalidate) {
  var lastRefresh = {_v: Companion_getInstance_0().get_DISTANT_PAST_yzdqbd_k$()};
  var token = {_v: null};
  if (forceInvalidate == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    forceInvalidate.addListener_6y9mct_k$(() => {
      lastRefresh._v = Companion_getInstance_0().get_DISTANT_PAST_yzdqbd_k$();
      token._v = null;
      return Unit_instance;
    });
  }
  return accessToken$slambda(token, lastRefresh, _this__u8e3s4, sessionToken);
}
var LightningServerAuthenticationClass;
function LightningServerAuthentication() {
  if (LightningServerAuthenticationClass === VOID) {
    class $ {
      constructor(subject, subjectPath, sessionToken) {
        this.subject_1 = subject;
        this.subjectPath_1 = subjectPath;
        this.sessionToken_1 = sessionToken;
        this.accessToken_1 = accessToken(this.subject_1, this.sessionToken_1);
      }
      toString() {
        return 'LightningServerAuthentication(subject=' + toString(this.subject_1) + ', subjectPath=' + this.subjectPath_1 + ', sessionToken=' + this.sessionToken_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.subject_1);
        result = imul(result, 31) + getStringHashCode(this.subjectPath_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.sessionToken_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LightningServerAuthentication()))
          return false;
        if (!equals(this.subject_1, other.subject_1))
          return false;
        if (!(this.subjectPath_1 === other.subjectPath_1))
          return false;
        if (!(this.sessionToken_1 === other.sessionToken_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LightningServerAuthentication');
    LightningServerAuthenticationClass = $;
  }
  return LightningServerAuthenticationClass;
}
function accessToken$slambda$slambda($this_accessToken, $sessionToken) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    return yield* $this_accessToken.getTokenSimple_ybyi9u_k$($sessionToken, $completion);
  }), 1);
}
function accessToken$slambda($token, $lastRefresh, $this_accessToken, $sessionToken) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var toUse = $token._v;
    var tmp;
    var tmp_0;
    var tmp_1 = System_instance.now_2cba_k$().minus_bn4aoq_k$($lastRefresh._v);
    // Inline function 'kotlin.time.Companion.minutes' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(4, DurationUnit_MINUTES_getInstance());
    if (Duration__compareTo_impl_pchp0f(tmp_1, tmp$ret$0) > 0) {
      tmp_0 = true;
    } else {
      tmp_0 = toUse == null;
    }
    if (tmp_0) {
      $lastRefresh._v = System_instance.now_2cba_k$();
      var tmp_2 = get_AppScope();
      var out = async(tmp_2, VOID, VOID, accessToken$slambda$slambda($this_accessToken, $sessionToken));
      $token._v = out;
      toUse = out;
      tmp = Unit_instance;
    }
    return listOf_0(to('Authorization', yield* toUse.await_4rdzbx_k$($completion)));
  }), 0);
}
//region block: exports
export {
  AuthEndpoints as AuthEndpoints35rits72n531v,
  LightningServerAuthentication as LightningServerAuthentication1flu9knqaq6fy,
  accessToken as accessToken1dnygkyd4osr1,
};
//endregion

//# sourceMappingURL=authInterfaces.mjs.map
